import { createContext, useContext } from 'react'

const SectionMetaDataContext = createContext({})
const SectionIdContext = createContext(null)
const SectionKeyContext = createContext(null)
const SectionIndexContext = createContext(0)
const SectionActionsContext = createContext({
	visible: false,
	handleMouseEnter: () => {},
	handleMouseLeave: () => {},
})

export const SectionMetaDataProvider = SectionMetaDataContext.Provider

/**
 * @return {Object.<string, PageMetaData>}
 */
export const useSectionMetaData = () => {
	const context = useContext(SectionMetaDataContext)
	if (context === undefined) {
		throw new Error('useSectionMetaData must be used within a SectionMetaDataProvider')
	}
	return context
}

export const SectionIdProvider = SectionIdContext.Provider

export const SectionActionsProvider = SectionActionsContext.Provider

export const SectionIndexProvider = SectionIndexContext.Provider

/**
 * @return {string|number|null}
 */
export const useSectionId = () => {
	const context = useContext(SectionIdContext)
	if (context === undefined) {
		throw new Error('useSectionId must be used within a SectionIdProvider')
	}
	return context
}

export const SectionKeyProvider = SectionKeyContext.Provider

/**
 * @return {string|null}
 */
export const useSectionKey = () => {
	const context = useContext(SectionKeyContext)
	if (context === undefined) {
		throw new Error('useSectionKey must be used within a SectionKeyProvider')
	}
	return context
}

export const useSectionActions = () => {
	const context = useContext(SectionActionsContext)

	if (context === undefined) {
		throw new Error('useSectionActions must be used within a SectionActionsContext')
	}
	return context
}

export const useSectionIndex = () => {
	return useContext(SectionIndexContext)
}
